// import React from 'react'
// import CA_letter from './image/CA_letter.jpeg'
// import CA_cer from './image/CA_cer.jpeg'
// import CA_letter2 from './image/CA_letter2.jpeg'

// const certificates = [
//     { src: CA_letter, alt: 'Certificate 1' },
//     { src: CA_letter2, alt: 'Certificate 3' },
//     { src: CA_cer, alt: 'Certificate 2' },

//   ];

// function CA_certification() {
//   return (
//     <div>
//       <div>
//       <div className='container py-4 d-sm-block d-md-none'>
//         <div className='row'>
//           <div className='col-md-1'></div>
//           <div className='col-md-10'>
//             <div className='text-center About_Discraption_text'>
//               <h1 className='display-5 pb-2'>Certificates</h1>
//               <p className='fs-6'>Prove Your Knowledge with Our Highly Esteemed Certifications, valued in All Professions.</p>
//             </div>
//           </div>
//           <div className='col-md-1'></div>
//         </div>
//         <div className='row'>
//           {certificates.map((certificate, index) => (
//             <div className='col-md-4' key={index}>
//               <div className='p-2'>
//                 <img className='mobile_Certificates_img shadow' src={certificate.src} alt={certificate.alt} />
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       <div className='container py-5 d-none d-md-block'>
//         <div className='row'>
//           <div className='col-md-1'></div>
//           <div className='col-md-10'>
//             <div className='text-center About_Discraption_text'>
//               <h1 className='display-4 pb-2'>Certificates</h1>
//               <p className='fs-5'>Prove Your Knowledge with Our Highly Esteemed Certifications, valued in All Professions.</p>
//             </div>
//           </div>
//           <div className='col-md-1'></div>
//         </div>
//         <div className='row mt-4'>
//           {certificates.map((certificate, index) => (
//             <div className='col-6 p-2' key={index}>
//               <img className='CA_Certificates shadow' src={certificate.src} alt={certificate.alt} />
//             </div>
//           ))}
//         </div>
//       </div>
//     </div>
//     </div>
//   )
// }

// export default CA_certification
import React from 'react'
import CA_letter from './image/CA_letter.jpeg'
import CA_cer from './image/CA_cer.jpeg'
import CA_letter2 from './image/CA_letter2.jpeg'

const certificates = [
  { src: CA_letter, alt: 'Certificate 1' },
  { src: CA_letter2, alt: 'Certificate 3' },
  { src: CA_cer, alt: 'Certificate 2' },
]

function CA_certification() {
  return (
    <div>
      <div className="container py-4 d-sm-block d-md-none">
        <div className="row">
          <div className="col-md-1"></div>
          <div className="col-md-10 text-center">
            <div className="CA_Certificates_mobile">
              <h1 className="display-5 pb-1">Certificates</h1>
              <p className="">
                Prove Your Knowledge with Our Highly Esteemed Certifications,
                valued in All Professions.
              </p>
            </div>
          </div>
          <div className="col-md-1"></div>
        </div>
        <div className="row">
          {' '}
          {certificates.map((certificate, index) => (
            <div className="col-md-4" key={index}>
              <div className="p-2">
                <img
                  className="mobile_Certificates_img shadow"
                  src={certificate.src}
                  alt={certificate.alt}
                />
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="container pt-5 d-none d-md-block">
        <div className="row">
          <div className="col-md-1"></div>
          <div className="col-md-10 CA_Certificates text-center">
              <h1 className="display-5 pb-2">Certificates</h1>
              <p className="">
                Prove Your Knowledge with Our Highly Esteemed Certifications,
                valued in All Professions.
              </p>
          </div>
          <div className="col-md-1"></div>
        </div>
        <div className='row mt-4'>
          {certificates.map((certificate, index) => (
            <div
              className={`col-${index === certificates.length - 1 ? 8 : 6} ${index === certificates.length - 1 ? 'offset-2' : ''} p-3 text-center`}
              key={index}
            >
              <img className='CA_Certificates shadow' src={certificate.src} alt={certificate.alt} />
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default CA_certification
